module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-ExtraBold-5398a527.eot";